import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** オフバランスの資産管理区分 */
enum OffBalanceAsset {
  normal = '1',
  unaccounted = '4',
}

const nameConfig = {
  normal: new Map([[Locale.ja, '通常資産']]),
  unaccounted: new Map([[Locale.ja, '簿外資産']]),
};

const toEnum = rawValueToEnum(OffBalanceAsset, OffBalanceAsset.normal);
const toDisplay = enumToName(OffBalanceAsset, nameConfig);
const toDisplayWithPrefix = enumToName(OffBalanceAsset, nameConfig, { prefix: true });

export const offBalanceAsset = {
  enum: OffBalanceAsset,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { OffBalanceAsset };
